const SELECTORS = {
    section: '.block-team',
    card: '.js--team-card',
    toggle: '.js--team-toggle',
};
const INIT_ATTR = 'data-team-init';
const initCard = (card) => {
    const toggle = card.querySelector(SELECTORS.toggle);
    if (!toggle)
        return;
    const bioId = toggle.getAttribute('aria-controls');
    const bio = bioId ? document.getElementById(bioId) : null;
    bio?.setAttribute('aria-hidden', 'true');
    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        card.classList.toggle('is-open', !isOpen);
        bio?.setAttribute('aria-hidden', String(isOpen));
    });
};
const init = () => {
    document.querySelectorAll(SELECTORS.section).forEach((section) => {
        if (section.hasAttribute(INIT_ATTR))
            return;
        section.setAttribute(INIT_ATTR, '');
        section.querySelectorAll(SELECTORS.card).forEach(initCard);
    });
};
document.addEventListener('DOMContentLoaded', init);
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
export default init;
